import { ReactElement } from "react";

export function Favicons(): ReactElement | null {
  return null;
}
